import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import { getFlagPath } from '../../shared/useUtils';
import { HeroCountryStyle } from '../../styles/components/country';
import { HighlightedTitle } from '../common/ui';

interface IHeroCountryTip {
  iconPath: string;
  text: string;
  action?: () => void | Promise<void>;
}

export interface IHeroCountry {
  title: string;
  countryCode: string;
  tips: IHeroCountryTip[];
  titleHighlightedText?: string | undefined | null;
  description?: string;
}

const HeroCountryTip = (props: IHeroCountryTip) => {
  return (
    <div
      className={`${HeroCountryStyle['hero-country-tip']} ${
        props.action ? HeroCountryStyle['hero-country-tip-clickable'] : ''
      }`}
      onClick={props.action}>
      <Image
        className={'colorize-primary'}
        quality={50}
        src={props.iconPath}
        priority={false}
        width={16}
        height={16}
        alt={props.text}
      />
      <ReactMarkdown>{props.text}</ReactMarkdown>
    </div>
  );
};

const HeroCountry = (props: IHeroCountry) => {
  return (
    <div className={HeroCountryStyle['hero-country']}>
      <div className={HeroCountryStyle['hero-country-top']}>
        {!!props.titleHighlightedText ? (
          <HighlightedTitle
            text={props.title}
            highlightedText={props.titleHighlightedText}
            headingTagName="h1"
            highlightedSlot={
              <Image
                quality={90}
                alt={`country-flag-${props.countryCode}`}
                src={getFlagPath(props.countryCode)}
                width={80}
                height={50}
                style={{ width: 'auto' }}
                priority
              />
            }
          />
        ) : (
          <h1>{props.title}</h1>
        )}
        {/* <div className={HeroCountryStyle['hero-country-tips-container']}>
          {(props.tips as IHeroCountryTip[]).map((tip: any, index: number) => {
            return <HeroCountryTip key={index} {...tip} />;
          })}
        </div> */}
        {props.description && (
          <div className={HeroCountryStyle['hero-country-description']}>
            <ReactMarkdown>{props.description}</ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroCountry;
